<template>
  <Carousel
  v-if="changes.length"
  class="text-center mt-1"
    :per-page="1"
    :mouse-drag="true"
    :autoplay="true"
    :loop="true"
    autoplayDirection="forward"
    :paginationEnabled="false"
    :speed="1500"
  >
    <slide>
        <p><b>🇨🇴 Cambio Colombia:</b> Sacoin a la <u>compra</u>: {{this.changes[2].change}}</p>
    </slide>
    <slide>
        <p><b>🇲🇽 Cambio México:</b> Sacoin a la <u>compra</u>: {{this.changes[3].change}}</p>
    </slide>
    <slide>
        <p><b>🇦🇷 Cambio Argentina:</b> Sacoin a la <u>compra</u>: {{this.changes[4].change}}</p>
    </slide>
    <slide>
        <p><b>🇨🇱 Cambio Chile:</b> Sacoin a la <u>compra</u>: {{this.changes[5].change}}</p>
    </slide>
    <slide>
        <p><b>🇵🇪 Cambio Perú:</b> Sacoin a la <u>compra</u>: {{this.changes[6].change}}</p>
    </slide>
    <slide>
        <p><b>🇧🇴 Cambio Bolivia:</b> Sacoin a la <u>compra</u>: {{this.changes[7].change}}</p>
    </slide>
    <slide>
        <p><b>💶 Cambio Euro:</b> Sacoin a la <u>compra</u>: {{this.changes[8].change}}</p>
    </slide>
    <slide>
        <p><b>₿ Cambio Bitcoin:</b> Sacoin a la <u>compra</u>: {{this.changes[0].change}}</p>
    </slide>
    <slide>
        <p><b>🇺🇸 Cambio USA:</b> Sacoin a la <u>compra</u>: {{this.changes[1].change}}</p>
    </slide>
  </Carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import Api from "../tools/Api2";

export default {
  name: "CurrenciesCarousel",
  data() {
    return {
        changes: []
    };
  },
  components: {
    Carousel,
    Slide,
  },
  methods: {},
  created: function () {
      Api("tipo-cambio").get().then(res => {
      for (const change in res.changes) {
        !change.includes("Venta")
          ? this.changes.push({
              change: Number(res.changes[change]),
              currency: change.split("-")[0],
            })
          : false;
      }
    });
  },
};
</script>